import { useState, useCallback, useEffect } from 'react';
import { getMemberGrowth } from 'src/shared/services/statisticsService';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { MemberGrowthResponse } from '../models/memberGrowthResponse';
import { MemberGrowthSearchFilter } from '../models/memberGrowthSearchFilter';

export const useMemberGrowth = (searchFilter: MemberGrowthSearchFilter) => {
  const [memberGrowth, setMemberGrowth] = useState<MemberGrowthResponse>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isMounted = useIsMounted();

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getMemberGrowth(searchFilter);
      if (isMounted()) {
        ConsoleHelper.log('RES MemberGrowth', res.data);
        setMemberGrowth(res.data);
      }
    } catch (error) {
      ConsoleHelper.log(error);
    } finally {
      if (isMounted()) {
        setIsLoading(false);
      }
    }
  }, [isMounted, searchFilter]);

  useEffect(() => {
    if (searchFilter.fromSnapshotTimeId > 0) fetchData();
  }, [fetchData, searchFilter.fromSnapshotTimeId]);

  return { memberGrowth, isLoading, fetchData };
};
